import React from 'react'

interface IButtonProps {
  label: string
  style?: string
  alignLeft?: boolean
  onClick: () => void
}

const UIButton: React.FC<IButtonProps> = ({
  label,
  style,
  alignLeft,
  onClick,
}: IButtonProps) => {
  return (
    <button
      className={`stat-button-link group absolute w-full h-[50%] sm:w-[50%] sm:h-full flex justify-center items-center ${
        alignLeft ?? false ? 'top-0 sm:left-0' : 'bottom-0 sm:right-0'
      } ${style !== undefined ? style : ''}`}
      onClick={onClick}
      data-dtm="turbomax engine"
    >
      <div
        className={`min-w-[200px] p-3 border-[1px] lg:border-2 border-gold duration-100 transition-colors bg-black-0.3 group-hover:bg-gold-hover group-active:bg-gray-light-press font-header uppercase font-bold text-white tracking-widest text-lg xl:text-xl 2xl:text-2xl ${
          alignLeft ?? false
            ? 'mb-[7vh] sm:mb-0 sm:mr-[10vh]'
            : 'mt-[7vh] sm:mt-0 sm:ml-[10vh]'
        }`}
      >
        {label}
      </div>
    </button>
  )
}

export default UIButton
